import BigDarkBadge from 'core/assets/badges/BigDark.svg'
import BigDarkwithOrangeBadge from 'core/assets/badges/BigDarkwithOrange.svg'
import BigGreenBadge from 'core/assets/badges/BigGreen.svg'
import BigOrangeBadge from 'core/assets/badges/BigOrange.svg'
import BigWhiteBadge from 'core/assets/badges/BigWhite.svg'
import MediumDarkBadge from 'core/assets/badges/MediumDark.svg'
import MediumDarkwithOrangeBadge from 'core/assets/badges/MediumDarkwithOrange.svg'
import MediumGreenBadge from 'core/assets/badges/MediumGreen.svg'
import MediumOrangeBadge from 'core/assets/badges/MediumOrange.svg'
import MediumWhiteBadge from 'core/assets/badges/MediumWhite.svg'
import SmallDarkBadge from 'core/assets/badges/SmallDark.svg'
import SmallDarkwithOrangeBadge from 'core/assets/badges/SmallDarkwithOrange.svg'
import SmallGreenBadge from 'core/assets/badges/SmallGreen.svg'
import SmallOrangeBadge from 'core/assets/badges/SmallOrange.svg'
import SmallWhiteBadge from 'core/assets/badges/SmallWhite.svg'

const badges = [
  { id: 'BigDark', url: BigDarkBadge },
  { id: 'BigDarkwithOrange', url: BigDarkwithOrangeBadge },
  { id: 'BigGreen', url: BigGreenBadge },
  { id: 'BigOrange', url: BigOrangeBadge },
  { id: 'BigWhite', url: BigWhiteBadge },
  { id: 'MediumDark', url: MediumDarkBadge },
  { id: 'MediumDarkwithOrange', url: MediumDarkwithOrangeBadge },
  { id: 'MediumGreen', url: MediumGreenBadge },
  { id: 'MediumOrange', url: MediumOrangeBadge },
  { id: 'MediumWhite', url: MediumWhiteBadge },
  { id: 'SmallDark', url: SmallDarkBadge },
  { id: 'SmallDarkwithOrange', url: SmallDarkwithOrangeBadge },
  { id: 'SmallGreen', url: SmallGreenBadge },
  { id: 'SmallOrange', url: SmallOrangeBadge },
  { id: 'SmallWhite', url: SmallWhiteBadge }
]

export default badges
